import React, {useContext, useEffect, useState} from 'react'
import ReactModal from 'react-modal';
import {hasHikedTrail, nationalParks} from "../utils/NationalParksUtils";
import CircularProgressWithLabel from "../utils/CircularProgressWithLabel";
import CircularProgress from "../TripModal";
import Image from "../Image";
import axios from "axios";
import {getBearerToken, getServerUrl} from "../utils/utils";
import Chip from "@mui/material/Chip";
import {useParams} from "react-router-dom";
import {UserContext} from "../UserContext";
import Avatar from "@mui/material/Avatar";
import AddIcon from '@mui/icons-material/Add';
import CreateActivity from "../CreateActivity";
import CreateTrip from "../CreateTrip";

function NationalParkModal({selectedNationalPark, selectedNationalParkObj, trips, onHoverHikingTrailBox}) {
    const {id} = useParams()
    const {user} = useContext(UserContext)
    const [nationalParkTrips, setNationalParkTrips] = useState([])
    const [selectedHikingTrail, setSelectedHikingTrail] = useState(null)
    const [shouldRetrieveImages, setShouldRetrieveImages] = useState(false)
    const [images, setImages] = useState([])
    const [allImages, setAllImages] = useState([])
    const [retrievingImages, setRetrievingImages] = useState(false)
    const [selectedTripId, setSelectedTripId] = useState(null)
    const [hoveredTripId, setHoveredTripId] = useState(null)
    const [hoveredHikingTrail, setHoveredHikingTrail] = useState(null)
    const [openActivityModal, setOpenActivityModal] = useState(false)
    const [openCreateTripModal, setOpenCreateTripModal] = useState(false)

    const isScrollAtBottom = (element) => {
        const num = Math.abs(element.scrollHeight - element.clientHeight - element.scrollTop)
        return num <= 10;
    }

    const handleScroll = () => {
        const myDiv = document.querySelector('.fullscreen-national-park-images-div');
        if (isScrollAtBottom(myDiv)) {
            if (!shouldRetrieveImages && !retrievingImages && (allImages?.length !== images.length && allImages?.length > 12)) {
                setShouldRetrieveImages(true)
            }
        }
    }

    const fetchTrips = async () => {
        axios.get(`${getServerUrl()}/user/${id || user?.id}/categoryItem/${selectedNationalPark}`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setNationalParkTrips(response.data)
                if (response.data.length > 0) {
                    setSelectedTripId(response.data[0].id)
                }
            })
    }
    useEffect(() => {
        if (selectedNationalPark) {
            const nationalParkObj = nationalParks.find(nationalPark => nationalPark.name === selectedNationalPark)
            // axios.post(`${getServerUrl()}/nationalPark/${selectedNationalPark}`, {
            //     boundary: JSON.stringify(nationalParkObj.boundary),
            //     trails: JSON.stringify(nationalParkObj.trails),
            // }, {
            //
            // })
            //     .then(res => {
            //         console.log(res)
            //     })
            fetchTrips()
        }
    }, [selectedNationalPark])


    useEffect(() => {
        const retrieveImages = setTimeout(() => {
            if (shouldRetrieveImages) {
                setShouldRetrieveImages(false)
                if ((allImages?.length !== images.length && allImages?.length > 12)) {
                    retrieveImagesInBatches(images.length)
                }
            }
        }, 250)
        return () => clearTimeout(retrieveImages)
    }, [allImages, images, shouldRetrieveImages, selectedHikingTrail, selectedTripId])

    useEffect(() => {
        if (selectedTripId) {
            setImages([])
            retrieveImagesInBatches(0)
        }
    }, [selectedTripId])

    useEffect(() => {
        if (selectedHikingTrail) {
            setImages([])
            retrieveImagesInBatches(0)
        }
    }, [selectedHikingTrail])

    const retrieveImagesInBatches = async (startIndex) => {
        setRetrievingImages(true)
        const retrieveTripPhotos = selectedTripId && !selectedHikingTrail
        const endpoint = retrieveTripPhotos ? `${getServerUrl()}/trip/${selectedTripId}/images?loadCoverImage=true&shortenVideo=true&loadAsBatch=true&batchLoadIndex=${startIndex}`
            : `${getServerUrl()}/hikingTrail/${selectedHikingTrail}/images?batchLoadIndex=${startIndex}`
        axios.get(endpoint, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                setRetrievingImages(false)
                if (startIndex === 0) {
                    setAllImages(response.data)
                }
                const newImages = response.data.slice(0, response.data.length > 12 ? 12 : response.data.length)
                if (startIndex === 0) {
                    setImages(newImages)
                } else {
                    setImages(currentImages => {
                        const updatedCurrentImages = [...currentImages]
                        updatedCurrentImages.push(...newImages)
                        return updatedCurrentImages
                    })


                }
            })
    }

    const nationalParkObj = nationalParks.find(nationalPark => nationalPark.name === selectedNationalPark)

    const getUniqueHikingTrails = () => {
        const hikingTrailMap = {}
        if (selectedNationalParkObj) {
            const trails = JSON.parse(selectedNationalParkObj?.trails)
            return trails?.features?.filter(hikingTrail => {
                if (!hikingTrailMap[hikingTrail.properties.TRLNAME]) {
                    hikingTrailMap[hikingTrail.properties.TRLNAME] = true
                    return true
                } else {
                    return false
                }
            })
        }
        return []
    }


    const displayHikingTrailsList = (isLeft) => {
        const hikingTrailList = getUniqueHikingTrails()


        return hikingTrailList?.map((hikingTrail, index) => {
            const trailAlreadyHiked = hasHikedTrail(trips, hikingTrail.properties.TRLNAME, selectedNationalPark)
            return (
                <div
                    className={`individual-hike-container ${trailAlreadyHiked ? "" : "not-visited"}`}
                    onClick={() => {
                        setSelectedTripId(null)
                        setSelectedHikingTrail(hikingTrail.properties.TRLNAME)
                    }
                    }
                    onMouseEnter={() => onHoverHikingTrailBox(hikingTrail.properties)}
                    onMouseLeave={() => onHoverHikingTrailBox(null)}
                >
                    {/*<img src={state.logo}/>*/}
                    <strong>{`${hikingTrail.properties.TRLNAME}`}</strong>
                </div>
            )
        })
    }

    const displayTrailsUserHasHiked = () => {
        const hikingTrailList = getUniqueHikingTrails()

        const hikingTrailDisplayList = hikingTrailList?.filter(hikingTrail => {
            return hasHikedTrail(trips, hikingTrail.properties.TRLNAME, selectedNationalPark)
        }).map((hikingTrail, index) => {
            const trailStyle = {
                filter: "brightness(1.0)"
            }
            if (selectedHikingTrail === hikingTrail.properties.TRLNAME) {
                trailStyle.backgroundColor = "rgba(0, 0, 0, 0.08)"
            }
            if (hoveredHikingTrail === hikingTrail.properties.TRLNAME) {
                trailStyle.filter = "brightness(0.9)"
            }
            return (
                <>
                    <div
                        className="national-park-hike-container"
                        style={trailStyle}
                        onClick={() => {
                            setSelectedTripId(null)
                            setSelectedHikingTrail(hikingTrail.properties.TRLNAME)
                        }}
                        onMouseEnter={() => {
                            setHoveredHikingTrail(hikingTrail.properties.TRLNAME)
                            onHoverHikingTrailBox(hikingTrail.properties)
                        }}
                        onMouseLeave={() => {
                            setHoveredHikingTrail(null)
                            onHoverHikingTrailBox(null)
                        }}
                    >
                        <div className="national-park-trip-name">{hikingTrail.properties.TRLNAME}</div>
                    </div>
                    {/*<Chip*/}
                    {/*    avatar={<Avatar alt="Natacha" src={trip.trip_profile_image} />}*/}
                    {/*    label={trip.name}*/}
                    {/*    size="medium"*/}
                    {/*/>*/}
                </>
            )
        })
        hikingTrailDisplayList.unshift(
            <div className="add-hiking-trail-activity" onClick={() => {
                setOpenActivityModal(true)
            }}>
                <AddIcon/>
            </div>
        )
        return hikingTrailDisplayList
    }

    const uniqueHikingTrails = getUniqueHikingTrails()
    const numTrailsHiked = uniqueHikingTrails?.filter(trail => {
        let hikedTrail = false
        trips.forEach(trip => {
            trip.activities.forEach(activity => {
                if (activity.categoryItemDetail1 === trail.properties.TRLNAME && activity.categoryItem === selectedNationalPark) {
                    hikedTrail = true
                }
            })
        })
        return hikedTrail
    }).length

    const imageList = images.filter(image => {
        return image.image_location || image.video_location
    }).map(image => {
        return <Image imageFile={image} onClick={() => {
        }} imageIdsForNewActivity={[]}
                      key={image.id} showVideoCoverImage={true}/>
    })


    const displayTripList = () => {
        return nationalParkTrips.map(trip => {

            const tripStyle = {
                opacity: 1.0
            }
            if (trip.id === selectedTripId) {
                tripStyle.backgroundColor = "rgba(0, 0, 0, 0.08)"
            }
            if (trip.id === hoveredTripId) {
                tripStyle.opacity = 0.8
            }

            return (
                <>
                    <div
                        className="national-park-trip-container"
                        style={tripStyle}
                        onClick={() => {
                            setSelectedTripId(trip.id)
                            setSelectedHikingTrail(null)
                        }}
                        onMouseEnter={() => setHoveredTripId(trip.id)}
                        onMouseLeave={() => setHoveredTripId(null)}
                    >
                        <div className="national-park-trip-profile-pic">
                            <img src={trip.trip_profile_image}/>
                        </div>
                        <div className="national-park-trip-name">{trip.name}</div>
                    </div>
                    {/*<Chip*/}
                    {/*    avatar={<Avatar alt="Natacha" src={trip.trip_profile_image} />}*/}
                    {/*    label={trip.name}*/}
                    {/*    size="medium"*/}
                    {/*/>*/}
                </>
            )
        })

    }

    return (
        <>
            <div className="national-park-modal">
                {/*<div className="hiking-list national-parks-list" style={{left: 0}} id="">*/}
                {/*    {displayHikingTrailsList(true)}*/}
                {/*</div>*/}
                {/*<div className="states-list national-parks-list" style={{right: 0}}>*/}
                {/*    {displayNationalParksList(false)}*/}
                {/*</div>*/}
                <div className="national-park-modal-header">
                    <div className="national-park-logo-title-trips">
                        <div>
                            <img src={nationalParkObj?.logo}/>
                        </div>
                        <div className="national-park-logo-progress-container">
                            <div>
                                <h2 style={{color: "#6F4930"}}>{selectedNationalPark}</h2>
                                <button className="create-national-park-trip-button" onClick={() => {
                                    setOpenCreateTripModal(true)
                                }}>
                                    Create Trip
                                </button>
                            </div>
                            <div className="national-park-trip-list-container">{displayTripList()}</div>
                        </div>
                    </div>
                    {/*<div className="national-park-hikes-container">*/}
                    {/*    <h5>Your recent hikes</h5>*/}
                    {/*    <div className="modal-hiking-list">*/}
                    {/*    {displayTrailsUserHasHiked()}*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <div className="fullscreen-national-park-images-div" onScroll={() => handleScroll()}>
                        {imageList}
                        {shouldRetrieveImages && (
                            <div className="circular-progress-div">
                                <div className="circular-progress-images">
                                    <CircularProgress size={35}/>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

            </div>
            {getUniqueHikingTrails()?.length > 0 && (
                <div id="hiking-list-modal">
                    <div className="hiking-trail-progress">
                        <div style={{color: "#213A1B"}}>{`${numTrailsHiked} trails hiked`}</div>
                        <div
                            style={{color: "#C56C39"}}>{`${uniqueHikingTrails?.length - numTrailsHiked} trails remaining`}</div>
                    </div>
                    {displayTrailsUserHasHiked()}
                    <CreateActivity
                        open={openActivityModal}
                        onClose={newActivity => {
                            if (newActivity) {
                                fetchTrips()
                            }
                            setOpenActivityModal(false)
                        }}
                        trips={trips.filter(trip => trip.categoryItem === selectedNationalPark)}
                        selectedCategory="National Park"
                        selectedCategoryItem={selectedNationalPark}
                    />
                </div>
            )}
            <CreateTrip
                selectedCategory="National Park"
                selectedLocation={selectedNationalPark}
                selectedCategoryItem={selectedNationalPark}
                open={openCreateTripModal}
                selectedCountry="United States"
                selectedState={nationalParks.find(nationalPark => nationalPark.name === selectedNationalPark)?.state}
                onClose={() => {
                    setOpenCreateTripModal(false)
                    fetchTrips()
                }}
            />
        </>
    )

}

export default NationalParkModal;